var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import fastdom from 'fastdom';
import { isEmpty, isFunction } from 'mc-ui-utils';
import React, { Component, createRef } from 'react';
import highlightEvent from './analytics/HighlightEvent';
import FeedLoading from './components/FeedLoading';
import Glance from './components/Glance';
import LastScreen from './components/LastScreen';
import constants from './constants';
import { fetchExperiments } from './services';
import State from './state';
import { setCommonBridge } from './utils/bridgehelper';
import { getViewPortDimensions, setCoachMarkShown } from './utils/common';
import { getGlanceCards } from './utils/data';
import { getRegion, hasGlanceInterface } from './utils/glanceandroidbridge';
import { setupGondolinBridges } from './utils/gondolinbridge';
import { getUserId, registerHighlightsOnClose } from './utils/khazaddumbridge';
import { addListeners, clearAnimatingStyles, getPosition, removeListeners, resetCards, swipeAnimateCards, } from './utils/slider';
import { isPreferenceScreen, isStory } from './utils/typegaurds';
let isMoving = false;
class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentSlide: 0,
            bubbles: [],
            slideshowPaused: false,
            isVisible: true,
            experiments: {
                status: "idle" /* IDLE */,
                data: null,
                error: null,
            },
            hasDelayPassed: false,
        };
        this.isLongPress = false;
        this.lastVisibility = createRef();
        this.transitionEndListener = null;
        this.setGlanceIndex = (index) => {
            const { currentSlide } = this.state;
            this.setSlideIndex(index, currentSlide < index);
        };
        this.setBubbles = (moreBubbles) => {
            const { bubbles } = this.state;
            if (isEmpty(bubbles) && !isEmpty(moreBubbles) && isStory(moreBubbles[0])) {
                // first bubble, setup highlightevent
                highlightEvent.setupEvent(moreBubbles[0].id);
            }
            this.setState({
                bubbles: [...bubbles, ...moreBubbles],
            });
        };
        this.onSwipeStart = (event) => {
            if (!State.isSlidePrevented && !isMoving) {
                this.xStart = getPosition(event).x;
                this.isLongPress = false;
                this.swipeStartTime = Date.now();
                this.longPressTimer = window.setTimeout(() => {
                    this.isLongPress = true;
                }, constants.LONG_PRESS_TIMER);
            }
        };
        this.onSwipeMove = (event) => {
            if (!this.xStart) {
                return;
            }
            if (this.longPressTimer) {
                clearTimeout(this.longPressTimer);
            }
            const { x } = getPosition(event);
            this.deltaX = x - this.xStart;
            isMoving = true;
            const isInThreshold = Math.abs(this.deltaX) <= this.screenWidth;
            const { totalGlances } = State;
            const { currentSlide } = this.state;
            if (((this.deltaX <= 0 && currentSlide < totalGlances) ||
                (this.deltaX > 0 && currentSlide > 0)) &&
                isInThreshold) {
                swipeAnimateCards(this.deltaX);
            }
        };
        this.updateIndex = (index) => {
            this.setState({
                currentSlide: index,
            });
            const { bubbles } = this.state;
            if (index === bubbles.length - 4 && State.isSdk) {
                getGlanceCards(this.setBubbles);
            }
        };
        this.setSlideIndex = (index, isNext = true) => {
            try {
                const { hasCoachMark } = State;
                const { currentSlide } = this.state;
                if (!State.isSdk && isFunction(this.props.onChangeGlanceIndex))
                    this.props.onChangeGlanceIndex(index);
                if (index === 1 && currentSlide === 0 && hasCoachMark) {
                    State.hasCoachMark = false;
                    setCoachMarkShown();
                }
                let card;
                if (isNext) {
                    card = document.querySelector('.current');
                }
                else {
                    card = document.querySelector('.prev');
                }
                if (currentSlide !== index && !isEmpty(card)) {
                    const styleText = isNext
                        ? `transform: translate3d(${-100}%, 0, 1px);`
                        : `transform: translate3d(0%, 0, 2px);`;
                    fastdom.mutate(() => {
                        card.style.cssText = styleText;
                    });
                    const onTransitionEnd = () => {
                        isMoving = false;
                        clearAnimatingStyles(card);
                        this.updateIndex(index);
                        this.transitionEndListener = null;
                        if (!isEmpty(card)) {
                            card.removeEventListener('transitionend', onTransitionEnd);
                        }
                    };
                    if (this.transitionEndListener) {
                        card.removeEventListener('transitionend', this.transitionEndListener);
                    }
                    this.transitionEndListener = onTransitionEnd;
                    card.addEventListener('transitionend', onTransitionEnd);
                }
                else {
                    isMoving = false;
                    clearAnimatingStyles(card);
                }
            }
            catch (err) {
                console.error(err);
            }
        };
        this.onSwipeEnd = () => {
            const endTime = Date.now();
            const velocity = this.deltaX / (endTime - this.swipeStartTime);
            const { currentSlide } = this.state;
            if (isMoving && this.deltaX && this.isLongPress === false) {
                const isFastEnough = Math.abs(velocity) > constants.SWIPE_VELOCITY_THRESHOLD;
                const isRightSwipe = this.deltaX < -this.tolerance || (isFastEnough && velocity < 0);
                const isLeftSwipe = this.deltaX > this.tolerance || (isFastEnough && velocity > 0);
                const { totalGlances } = State;
                if (isRightSwipe && currentSlide < totalGlances) {
                    State.lastPageChangeSource = "Swipe" /* SWIPE */;
                    this.setSlideIndex(currentSlide + 1);
                }
                else if (isLeftSwipe && currentSlide > 0) {
                    State.lastPageChangeSource = "Swipe" /* SWIPE */;
                    this.setSlideIndex(currentSlide - 1, false);
                }
                else {
                    this.setSlideIndex(currentSlide);
                    resetCards();
                }
            }
            else {
                this.setSlideIndex(currentSlide);
                resetCards();
            }
            this.swipeStartTime = null;
            this.xStart = null;
            this.deltaX = null;
        };
        this.visibilityChange = () => {
            const isVisible = document.visibilityState === 'visible';
            this.setState({
                slideshowPaused: !isVisible,
            });
        };
        this.fireHighlightEvent = () => {
            try {
                const { currentSlide, bubbles } = this.state;
                const currentStory = bubbles[currentSlide];
                let endBubble;
                if (isStory(currentStory)) {
                    endBubble = currentStory.id;
                }
                else {
                    const prevStory = bubbles[currentSlide - 1];
                    if (isStory(prevStory)) {
                        endBubble = prevStory.id;
                    }
                }
                if (isEmpty(highlightEvent.startBubble) &&
                    !isEmpty(bubbles) &&
                    isStory(bubbles[0])) {
                    highlightEvent.startBubble = bubbles[0].id;
                }
                highlightEvent.highlightEnd(endBubble);
                highlightEvent.fireEvent();
            }
            catch (err) {
                console.error(err);
            }
        };
        if (State.isSdk) {
            setCommonBridge();
            setupGondolinBridges();
        }
        this.screenWidth = parseInt(getViewPortDimensions().vw, 10);
        this.tolerance = this.screenWidth / 2;
    }
    componentDidMount() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            (_a = document.getElementById('loader')) === null || _a === void 0 ? void 0 : _a.remove();
            const { glances: glances, isSDK } = this.props; // from experience PWA data gets loaded via PROPS
            console.timeEnd('apprendering');
            if (!isSDK) {
                this.setBubbles(glances);
                State.totalGlances = glances.length;
            }
            else {
                getGlanceCards(this.setBubbles);
            }
            const container = document.getElementById(constants.MAIN_BACKGROUND_ID);
            addListeners(container, {
                onSwipeStart: this.onSwipeStart,
                onSwipeMove: this.onSwipeMove,
                onSwipeEnd: this.onSwipeEnd,
            });
            window.addEventListener('beforeunload', this.fireHighlightEvent);
            // this doesnt work when webview moves to background, hence the window.onScreenVisibilityChange from SDK
            //document.addEventListener('visibilitychange', this.visibilityChange);
            window.onScreenVisibilityChange = (visiblityState, source) => {
                var _a;
                if (this.lastVisibility.current !== visiblityState) {
                    this.lastVisibility.current = visiblityState;
                    if (!isEmpty(source)) {
                        State.lastPageChangeSource = source;
                    }
                    if (!visiblityState) {
                        this.fireHighlightEvent();
                    }
                    else {
                        highlightEvent.reset((_a = this.state.bubbles[0]) === null || _a === void 0 ? void 0 : _a.id);
                    }
                    this.setState({
                        isVisible: visiblityState,
                    });
                }
            };
            // highlights destroyed
            window.onHighlightClose = () => {
                window.onScreenVisibilityChange(false, "LS" /* LOCKSCREEN */);
            };
            // activity goes to background / foreground
            registerHighlightsOnClose('window.onHighlightClose');
            if (isSDK && hasGlanceInterface()) {
                window.GlanceAndroidInterface.getBubbleTrayMode = () => "ALWAYS_OFF" /* ALWAYS_OFF */;
            }
            if (State.isSdk) {
                /***
                 * Fetching Experiments Config only in case of SDK
                 */
                this.setState((prevState) => (Object.assign(Object.assign({}, prevState), { experiments: Object.assign(Object.assign({}, prevState.experiments), { status: "loading" /* LOADING */ }) })));
                try {
                    const userId = getUserId();
                    const region = getRegion();
                    if (isEmpty(userId)) {
                        throw Error('User Id not available.');
                    }
                    if (isEmpty(region)) {
                        throw Error('Region not available.');
                    }
                    const response = yield fetchExperiments(userId, region);
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    const data = yield response.json();
                    this.setState((prevState) => (Object.assign(Object.assign({}, prevState), { experiments: {
                            status: "resolved" /* RESOLVED */,
                            data,
                            error: null,
                        } })));
                }
                catch (error) {
                    console.error(error);
                    this.setState((prevState) => (Object.assign(Object.assign({}, prevState), { experiments: {
                            status: "rejected" /* REJECTED */,
                            data: null,
                            error,
                        } })));
                }
            }
            else {
                /**
                 * Setting experiment status to ApiStatus.REJECTED
                 * to support glance-web-ssr
                 */
                this.setState((prevState) => (Object.assign(Object.assign({}, prevState), { experiments: {
                        status: "rejected" /* REJECTED */,
                        data: null,
                        error: {
                            message: 'Disabling Interaction Experiment',
                        },
                    } })));
            }
        });
    }
    componentWillUnMount() {
        const container = document.getElementById(constants.MAIN_BACKGROUND_ID);
        if (!isEmpty(container)) {
            removeListeners(container, {
                onSwipeStart: this.onSwipeStart,
                onSwipeMove: this.onSwipeMove,
                onSwipeEnd: this.onSwipeEnd,
            });
        }
        //document.removeEventListener('visibilitychange', this.visibilityChange);
    }
    shouldComponentUpdate(nextProps, nextState) {
        return (this.state.currentSlide !== nextState.currentSlide ||
            isEmpty(this.state.bubbles) ||
            this.state.bubbles.length - 1 === this.state.currentSlide ||
            this.state.slideshowPaused !== nextState.slideshowPaused ||
            this.state.isVisible !== nextState.isVisible ||
            this.state.hasDelayPassed !== nextState.hasDelayPassed ||
            this.state.experiments.status !== nextState.experiments.status);
        // To prevent rerendering when bubbles change second time etc
    }
    static getDerivedStateFromProps(props, state) {
        if (!props.isSDK && props.glances.length !== state.bubbles.length) {
            State.totalGlances = props.glances.length;
            return {
                bubbles: props.glances,
            };
        }
        if (!props.isSDK && props.isAutoPlayPaused !== state.slideshowPaused) {
            return {
                slideshowPaused: props.isAutoPlayPaused,
            };
        }
        return null;
    }
    render() {
        const { currentSlide, bubbles, slideshowPaused, isVisible, experiments, } = this.state;
        const renderingBubbles = [];
        for (let i = currentSlide - 3; i < currentSlide + 3; i = i + 1) {
            if (!isEmpty(bubbles[i])) {
                const bubble = bubbles[i];
                if (isStory(bubble)) {
                    const { id } = bubble;
                    renderingBubbles.push(React.createElement(Glance, { key: id, bubble: bubble, index: i, currentGlanceIndex: currentSlide, setSlideshowIndex: this.setGlanceIndex, slideshowPaused: slideshowPaused || !isVisible, isVisible: isVisible, experiments: experiments, setStoryIdInPWA: this.props.setStoryIdInPWA }));
                }
                else if (isPreferenceScreen(bubble) && State.isSdk) {
                    renderingBubbles.push(React.createElement(LastScreen, { index: i, setIndex: this.setGlanceIndex, isActive: currentSlide === i, key: `preference-screen`, isPrev2: currentSlide === i + 2, isNext: currentSlide === i - 1, isPrev: currentSlide === i + 1 }));
                }
            }
        }
        if (!isEmpty(renderingBubbles)) {
            return (React.createElement(React.Fragment, null,
                renderingBubbles,
                currentSlide > bubbles.length - 2 && (React.createElement(LastScreen, { isActive: currentSlide === bubbles.length, isNext: currentSlide === bubbles.length - 1, hasMore: false }))));
        }
        return React.createElement(FeedLoading, null);
    }
}
export default App;
//# sourceMappingURL=app.js.map